import Vue from 'vue';
import axios from "axios";
import {VuexParams, Params} from "@/interfaces/actionParamsInterface";

export function logout({ commit }: VuexParams, { callback }: Params) {
    axios
        .post(`${Vue.prototype.$baseUrl}/api/auth/logout`, {})
        .then(() => {
            callback()
        })
        .catch((error) => {
            callback({error: error.response?.data})
        })
}
